import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';

function GenericTextField({ formik, campo , ...rest }) {
  return (
    <TextField
      variant="standard"
      autoComplete={campo}
      inputProps={{autoComplete: `section-${campo}`}}
      id={campo}
      type='text'
      name={campo}
      label={campo.charAt(0).toUpperCase() + campo.slice(1)}
      value={formik.values[campo]}
      onChange={formik.handleChange}
      error={formik.touched[campo] && Boolean(formik.errors[campo])}
      helperText={formik.touched[campo] && formik.errors[campo]}
      {...rest} />
  );
}

GenericTextField.propTypes = {
  formik: PropTypes.object,
  campo: PropTypes.string,
  rest: PropTypes.any,
};

export default GenericTextField;
